import { useReducer } from 'react';

import * as listWithPlaceholder from '../../utils/listWithPlaceholder';
import reducer, { defaultState } from './newArrivalsReducer';

export const useData = () => {
  const [data, dispatch] = useReducer(reducer, defaultState);
  const { isFetching, products, currentPage = 1, hasMoreItems = false } = data;

  return {
    currentPage,
    isFetching,
    hasMoreItems,
    products: listWithPlaceholder.makeResultIdsWithFetching(
      products,
      isFetching
    ),
    dispatch,
  };
};
